module.exports = __webpack_public_path__ + "fonts/fa-light-300.woff";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/fontAwesome-5/webfonts/fa-light-300.woff
// module id = 359
// module chunks = 0